export default __webpack_public_path__ + "static/media/Addcircle.493497bc.svg";